import EntityType from "@/models/Shared/EntityType";

export default class EntityIdentifier {
    entityId: string = '';
    entityName: string = '';
    entityType: EntityType;
}
